import { create } from 'zustand';
import { ExpressOffer, FarmerExpressOffersState, Offer, Request } from '../types';

export const useFarmerExpressOffersStore = create<FarmerExpressOffersState>((set) => ({
	// Request state
	requests: [],
	isRequestsLoading: false,
	requestsError: null,
	requestsFilters: { status: [] },

	// Selected request and its offers
	selectedRequestId: null,
	offers: [],
	isOffersLoading: false,
	offersError: null,

	// Selected offer details (for detail page)
	selectedOffer: null,
	isOfferDetailLoading: false,
	offerDetailError: null,

	// Actions
	setRequests: (requests: Request[]) =>
		set(() => ({
			requests,
			isRequestsLoading: false,
			requestsError: null,
		})),

	setIsRequestsLoading: (isLoading: boolean) => set(() => ({ isRequestsLoading: isLoading })),

	setRequestsError: (error: string | null) =>
		set(() => ({
			requestsError: error,
			isRequestsLoading: false,
		})),

	setSelectedRequestId: (requestId: string | null) =>
		set(() => {
			// Just update the selected ID without changing loading state
			return {
				selectedRequestId: requestId,
				// Clear offers but don't set loading state, that will be handled by the page
				offers: [],
				offersError: null,
			};
		}),

	setOffers: (offers: Offer[]) =>
		set(() => ({
			offers,
			isOffersLoading: false,
			offersError: null,
		})),

	setIsOffersLoading: (isLoading: boolean) => set(() => ({ isOffersLoading: isLoading })),

	setOffersError: (error: string | null) =>
		set(() => ({
			offersError: error,
			isOffersLoading: false,
		})),

	// Selected offer detail actions
	setSelectedOffer: (offer: ExpressOffer | null) =>
		set(() => ({
			selectedOffer: offer,
			isOfferDetailLoading: false,
			offerDetailError: null,
		})),

	setIsOfferDetailLoading: (isLoading: boolean) => set(() => ({ isOfferDetailLoading: isLoading })),

	setOfferDetailError: (error: string | null) =>
		set(() => ({
			offerDetailError: error,
			isOfferDetailLoading: false,
		})),

	// Reset state
	resetState: () =>
		set(() => ({
			requests: [],
			isRequestsLoading: false,
			requestsError: null,
			requestsFilters: { status: [] },
			selectedRequestId: null,
			offers: [],
			isOffersLoading: false,
			offersError: null,
			selectedOffer: null,
			isOfferDetailLoading: false,
			offerDetailError: null,
		})),
}));
